/* ==========================================================================
   XRED · Serious theme · scroll motion (owner A · home)
   Mounts the scrollcraft engine (untouched, in scrollcraft.js) and carries
   the home page's own behaviour, ported from the static build:

     0. Phone switch (phone.js): pinned acts marked data-phone-flow run as
        flow sections on phones, data-phone-span shortens a pin. Runs BEFORE
        the engine mounts, on the whole document and again on every section
        the theme editor loads.
     1. Page veil (intro.js): the mark and the heat strip hold for a beat on
        the first page of a session, lift quickly after that, never hold
        longer than 2.5s. Only when the layout rendered a .veil.
     2. Anchor smooth scroll (main.js).
     3. SIGNATURE MOVE, the heat gauge (main.js): reads --sc-p off
        #sauces[data-sc-act="pan"] and sets --heat, --flame, --gp on :root.
        Only when <html data-xr-gauge="on"> and a .gauge exists.
     4. Rail card settle: the staggered arrival in xred-base.css reads --i off
        each .card; the static page hardcoded six nth-child rules, here the
        count is a merchant setting, so --i is set per card.
     5. Bundle builder (site.js): pick sauces, see the bundle price, add the
        REAL bundle product's variant through XRED.addToCart.

   The header solid/compact state and the mobile menu are NOT here; they live
   in xred-global.js (owner B). prefers-reduced-motion always wins, and the
   engine never mounts while the merchant has scroll motion off.
   ========================================================================== */
(function () {
  'use strict';

  var html = document.documentElement;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var motionOn = html.getAttribute('data-xr-motion') !== 'off';
  var gaugeOn = html.getAttribute('data-xr-gauge') !== 'off';
  var phone = matchMedia('(max-width: 860px)').matches;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function clamp(x, a, b) { return x < a ? a : x > b ? b : x; }
  function X() { return window.XRED || {}; }

  /* ------------------------------------------------ 0. phone switch */
  // Must run before ScrollCraft.mount reads the acts. Idempotent: an act
  // already switched is skipped, so a re-run on an editor-loaded section
  // touches only the new subtree.
  function phoneSwitch(root) {
    if (!phone) return;
    html.classList.add('is-phone');
    var scope = root || document;
    $$('[data-phone-flow]', scope).forEach(function (act) {
      if (act.__xrPhone) return; act.__xrPhone = true;
      act.setAttribute('data-sc-act', 'flow');
      act.removeAttribute('data-sc-span');
      $$('[data-sc-cue]', act).forEach(function (el) { el.removeAttribute('data-sc-cue'); });
      $$('[data-sc-kinetic]', act).forEach(function (el) { el.removeAttribute('data-sc-kinetic'); });
      $$('[data-phone-in]', act).forEach(function (el) {
        el.setAttribute('data-sc-in', '');
        if (!el.hasAttribute('data-sc-stagger')) el.setAttribute('data-sc-stagger', el.getAttribute('data-phone-in') || '70');
      });
    });
    $$('[data-phone-span]', scope).forEach(function (act) {
      act.setAttribute('data-sc-span', act.getAttribute('data-phone-span'));
    });
    // a wipe at the top of an act that stacks tall on phones: time it on the
    // element itself so it finishes while the element is still on screen
    $$('[data-phone-reveal-at]', scope).forEach(function (el) {
      el.setAttribute('data-sc-reveal-at', el.getAttribute('data-phone-reveal-at'));
      el.setAttribute('data-sc-reveal-self', '');
    });
  }

  /* ------------------------------------------------------- engine */
  var instance = null;
  function mountEngine() {
    if (!window.ScrollCraft || !motionOn) return;
    instance = window.ScrollCraft.mount(document.body);
  }
  function relayout() { if (instance && instance.layout) instance.layout(); }

  /* ------------------------------------------------- 1. page veil */
  function initVeil() {
    function toTop() {
      if (location.hash) return;
      try { scrollTo(0, 0); } catch (e) {}
      try { if (window.top !== window.self) html.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'instant' }); } catch (e) {}
    }
    var veil = $('.veil');
    if (!veil) { html.classList.remove('is-arriving'); return; }
    if (X().designMode) {
      // The editor reloads sections constantly; never hold the merchant's view.
      html.classList.add('has-arrived'); html.classList.remove('is-arriving');
      if (veil.parentNode) veil.parentNode.removeChild(veil);
      return;
    }
    toTop();
    requestAnimationFrame(toTop);
    addEventListener('load', toTop);
    addEventListener('pageshow', toTop);

    var seen = false;
    try { seen = sessionStorage.getItem('xred-intro') === '1'; } catch (e) {}
    if (seen) veil.classList.add('veil--quick');
    var hold = reduce ? 0 : (seen ? 240 : 1200);
    var started = performance.now(), done = false;
    function go() {
      if (done) return; done = true;
      html.classList.add('has-arrived'); html.classList.remove('is-arriving');
      veil.classList.add('veil--out');
      setTimeout(function () { if (veil.parentNode) veil.parentNode.removeChild(veil); }, reduce ? 0 : 700);
      try { sessionStorage.setItem('xred-intro', '1'); } catch (e) {}
    }
    function ready() { setTimeout(go, Math.max(0, hold - (performance.now() - started))); }
    if (document.readyState === 'complete') ready(); else addEventListener('load', ready);
    setTimeout(go, 2500);
  }

  /* ------------------------------------------- 2. anchor scrolling */
  // Delegated, so links in sections the editor loads later work too. Hash-only
  // hrefs and same-path hrefs (routes.root_url + '#sauces') both count. Links
  // that open something (quiz, cart, menu) are left to their own handlers.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (a.hasAttribute('data-quiz-open') || a.hasAttribute('data-cart-open') || a.hasAttribute('data-menu-close')) return;
    var href = a.getAttribute('href') || '';
    var hashAt = href.indexOf('#');
    var path = href.slice(0, hashAt);
    var id = href.slice(hashAt + 1);
    if (!id) return;
    if (path && path !== location.pathname && path !== location.pathname + location.search) return;
    var el = document.getElementById(id);
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  /* ------------------------------------------------- 3. heat gauge */
  var gaugeRAF = null;
  var colorProbe = null;
  function toRGB(c) {
    // Theme colours are hex; a merchant could paste rgb() or a named colour,
    // so resolve anything through the browser rather than parsing by hand.
    var m = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(String(c || '').trim());
    if (m) {
      var h = m[1]; if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
      return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
    }
    if (!colorProbe) { colorProbe = document.createElement('i'); colorProbe.style.display = 'none'; document.body.appendChild(colorProbe); }
    colorProbe.style.color = ''; colorProbe.style.color = c;
    var v = /rgba?\(([^)]+)\)/.exec(getComputedStyle(colorProbe).color);
    if (!v) return [225, 35, 39];
    var p = v[1].split(/[\s,\/]+/).map(parseFloat);
    return [p[0] || 0, p[1] || 0, p[2] || 0];
  }

  function initGauge() {
    if (reduce || !motionOn || !gaugeOn) return;
    var rail = document.getElementById('sauces');
    var gauge = $('.gauge');
    if (!rail || !gauge) return;
    if (gauge.__xrGauge) return; gauge.__xrGauge = true;
    if (gaugeRAF) cancelAnimationFrame(gaugeRAF);

    var stops = [];
    try { stops = JSON.parse(gauge.getAttribute('data-xr-stops') || '[]'); } catch (e) { stops = []; }
    stops = stops.map(function (s) { return { at: clamp(parseFloat(s.at) || 0, 0, 1), color: toRGB(s.color), level: s.level || '', name: s.name || '' }; })
      .sort(function (a, b) { return a.at - b.at; });
    if (stops.length < 2) return;
    var last = stops[stops.length - 1].at || 1;

    var levelEl = $('.gauge__level', gauge);
    var nameEl = $('.gauge__name', gauge);
    var lastKey = '';

    function mix(a, b, t) { return Math.round(a + (b - a) * t); }
    function colorAt(p) {
      for (var i = 0; i < stops.length - 1; i++) {
        var s = stops[i], n = stops[i + 1];
        if (p <= n.at) {
          var t = n.at === s.at ? 1 : clamp((p - s.at) / (n.at - s.at), 0, 1);
          return 'rgb(' + mix(s.color[0], n.color[0], t) + ',' + mix(s.color[1], n.color[1], t) + ',' + mix(s.color[2], n.color[2], t) + ')';
        }
      }
      return 'rgb(' + stops[stops.length - 1].color.join(',') + ')';
    }
    function labelAt(p) {
      var cur = stops[0];
      for (var i = 0; i < stops.length; i++) if (p >= stops[i].at - 0.06) cur = stops[i];
      return cur;
    }
    // The flame colour stops at the hottest sauce; the powder's grey must not
    // wash the fire out. That is the stop before the last one.
    var flameCap = stops.length > 2 ? stops[stops.length - 2].at : last;

    function loop() {
      if (!gauge.isConnected || !rail.isConnected) { gauge.__xrGauge = false; gaugeRAF = null; return; }
      var rect = rail.getBoundingClientRect();
      var active = rect.top < innerHeight * 0.5 && rect.bottom > innerHeight * 0.5;
      gauge.classList.toggle('gauge--on', active);
      if (active) {
        var p = parseFloat(getComputedStyle(rail).getPropertyValue('--sc-p')) || 0;
        html.style.setProperty('--heat', colorAt(p));
        html.style.setProperty('--flame', colorAt(Math.min(p, flameCap)));
        var gp = Math.min(1, p / last).toFixed(3);
        gauge.style.setProperty('--gp', gp);
        html.style.setProperty('--gp', gp);
        var l = labelAt(p);
        if (l.name + l.level !== lastKey) {
          lastKey = l.name + l.level;
          if (levelEl) levelEl.textContent = l.level;
          if (nameEl) nameEl.textContent = l.name;
        }
      }
      gaugeRAF = requestAnimationFrame(loop);
    }
    gaugeRAF = requestAnimationFrame(loop);
  }

  /* ------------------------------------------ 4. rail card settle */
  function initRailSettle(root) {
    $$('.rail', root || document).forEach(function (rail) {
      var i = 0;
      $$(':scope > .card', rail).forEach(function (card) { card.style.setProperty('--i', String(i++)); });
    });
  }

  /* ---------------------------------------------- 5. bundle builder */
  function money(cents) {
    var x = X();
    if (typeof x.formatMoney === 'function') return x.formatMoney(cents);
    return '$' + (cents / 100).toFixed(2);
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fill(tpl, vars) {
    return String(tpl || '').replace(/\[(\w+)\]/g, function (m, k) { return k in vars ? vars[k] : m; });
  }

  // Add through the shared cart API when B's global script has it; fall back
  // to the same POST + event so the drawer still opens if scripts load out
  // of order.
  function addToCart(payload) {
    var x = X();
    if (typeof x.addToCart === 'function') return Promise.resolve(x.addToCart(payload));
    var routes = x.routes || {};
    return fetch(routes.cartAdd || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body && (res.body.description || res.body.message) || (x.strings && x.strings.cartError) || 'Could not add to cart');
        document.dispatchEvent(new CustomEvent('xred:cart:added', { detail: res.body }));
        if (typeof x.setCartCount === 'function') {
          fetch((routes.cart || '/cart') + '.js').then(function (r) { return r.json(); }).then(function (c) { x.setCartCount(c.item_count); }).catch(function () {});
        }
        return res.body;
      });
  }

  function initBuilders(root) {
    $$('.builder[data-xr-builder]', root || document).forEach(function (builder) {
      if (builder.__xrBuilder) return; builder.__xrBuilder = true;

      var rules = [], strings = {};
      try { rules = JSON.parse(builder.getAttribute('data-xr-rules') || '[]'); } catch (e) {}
      try { strings = JSON.parse(builder.getAttribute('data-xr-strings') || '{}'); } catch (e) {}
      rules = rules.filter(function (r) { return r && r.price; });

      var picks = {};
      var out = $('.builder__total', builder), note = $('.builder__note', builder), addB = $('.builder__add', builder), box = $('.builder__box', builder);
      var addLabel = addB ? $('span', addB) : null;
      var addText = addLabel ? addLabel.textContent : '';

      function pickEls() { return $$('.builder__pick', builder); }
      function picked() { return pickEls().filter(function (b) { return picks[b.getAttribute('data-pick')]; }); }

      function ruleFor(sauces, powder) {
        for (var i = 0; i < rules.length; i++) {
          if (Number(rules[i].sauces) === sauces && !!rules[i].powder === powder) return rules[i];
        }
        return null;
      }
      function ruleCents(r) { return parseInt(r.cents, 10) || 0; }

      function state() {
        var sel = picked();
        var sauces = sel.filter(function (b) { return b.getAttribute('data-kind') !== 'powder'; }).length;
        var powder = sel.some(function (b) { return b.getAttribute('data-kind') === 'powder'; });
        var sum = sel.reduce(function (s, b) { return s + (parseInt(b.getAttribute('data-price'), 10) || 0); }, 0);
        var rule = ruleFor(sauces, powder);
        var hint = '';
        var sauceTotal = pickEls().filter(function (b) { return b.getAttribute('data-kind') !== 'powder'; }).length;
        var r3 = ruleFor(3, false), r3p = ruleFor(3, true), r4p = ruleFor(4, true);
        if (rule) {
          if (rule.sauces >= 4 && rule.powder) hint = strings.all || '';
          else if (rule.powder) hint = r4p && sauceTotal >= 4 ? (strings.fourth || '') : (strings.all || '');
          else {
            var diff = r3p && r3 ? ruleCents(r3p) - ruleCents(r3) : 0;
            hint = r3p ? fill(strings.powder, { price: money(diff) }) : '';
          }
        } else if (sauces >= 4 && !powder) {
          hint = r4p ? fill(strings.unlock, { price: r4p.price }) : '';
        } else if (sauces === 0) {
          hint = strings.pick || '';
        } else {
          var left = Math.max(1, 3 - sauces);
          hint = fill(left > 1 ? strings.more_other : strings.more_one, { count: left });
        }
        return { rule: rule, sum: sum, hint: hint, sel: sel };
      }

      function paint() {
        var s = state();
        pickEls().forEach(function (b) { b.setAttribute('aria-pressed', picks[b.getAttribute('data-pick')] ? 'true' : 'false'); });
        if (box) box.innerHTML = s.sel.map(function (b) {
          var img = $('img', b);
          return img ? '<img src="' + esc(img.currentSrc || img.src) + '" alt="" style="--heat:' + esc(b.style.getPropertyValue('--heat') || '') + '">' : '';
        }).join('');
        if (out) {
          if (s.rule) out.innerHTML = esc(s.rule.price) + (s.sum > ruleCents(s.rule) ? ' <s>' + esc(money(s.sum)) + '</s>' : '');
          else out.textContent = s.sum ? money(s.sum) : '';
        }
        if (note) note.textContent = (s.rule && s.rule.name ? s.rule.name + '. ' : '') + s.hint;
        if (addB) {
          var can = !!s.rule && (s.rule.variant || s.sel.every(function (b) { return b.getAttribute('data-variant'); }));
          addB.disabled = !can;
          if (addLabel) addLabel.textContent = addText;
        }
      }

      builder.addEventListener('click', function (e) {
        var b = e.target.closest('.builder__pick');
        if (b && builder.contains(b)) { var k = b.getAttribute('data-pick'); picks[k] = !picks[k]; paint(); return; }
        var add = e.target.closest('.builder__add');
        if (!add || add.disabled) return;
        var s = state();
        if (!s.rule) return;
        var payload;
        if (s.rule.variant) {
          payload = { id: parseInt(s.rule.variant, 10), quantity: 1, properties: {} };
          var names = s.sel.map(function (p) { return (p.getAttribute('data-name') || '').trim(); }).filter(Boolean).join(', ');
          if (names && strings.property) payload.properties[strings.property] = names;
        } else {
          // No bundle product configured for this combination: add the picks
          // themselves so the reader still gets what they chose.
          payload = { items: s.sel.map(function (p) { return { id: parseInt(p.getAttribute('data-variant'), 10), quantity: 1 }; }) };
        }
        add.disabled = true; add.classList.add('is-busy');
        addToCart(payload).then(function () {
          add.classList.remove('is-busy'); add.classList.add('is-done');
          if (addLabel && strings.added) addLabel.textContent = strings.added;
          picks = {};
          setTimeout(function () { add.classList.remove('is-done'); paint(); }, 1400);
        }).catch(function (err) {
          add.classList.remove('is-busy'); add.disabled = false;
          var x = X();
          if (typeof x.toast === 'function') x.toast((err && err.message) || (x.strings && x.strings.cartError) || 'Could not add to cart');
        });
      });
      paint();
    });
  }

  /* ------------------------------------------------------------ boot */
  function init(root) {
    phoneSwitch(root);
    initRailSettle(root);
    initBuilders(root);
    initGauge();
  }

  function boot() {
    phoneSwitch();
    mountEngine();
    initRailSettle();
    initBuilders();
    initGauge();
    initVeil();
  }
  if (document.readyState === 'loading') addEventListener('DOMContentLoaded', boot); else boot();

  // Theme editor: sections load and reload without a page refresh. Switch the
  // new subtree for phones first (the engine reads the attributes on mount),
  // then re-run the local inits and remount so new acts are collected.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    if (X().designMode) mountEngine(); else relayout();
  });
  document.addEventListener('shopify:section:reorder', relayout);
  document.addEventListener('shopify:section:unload', relayout);
  addEventListener('load', relayout);
})();
